<template lang="pug">
.home(:class="{ 'fade-in': isShowBg }")
  logoPage(
    v-if="currentPage === PAGE.LOGO"
    @next='goTo(PAGE.MILESTONE)'
    @showBg='bgShowUp'
    )
  milestonePage(
    v-if="currentPage === PAGE.MILESTONE"
    @next='goTo(PAGE.SCADA)'
    @skip='showLastPage'
    )
  scadaPage(
    v-if="currentPage === PAGE.SCADA"
    :showOverlay='currentPage === PAGE.SCADA'
    @next='goTo(PAGE.VIDEO)'
    )
  videoPage(
    v-if="currentPage === PAGE.VIDEO"
    )
</template>

<script>
import logoPage from '@/components/logo-page'
import milestonePage from '@/components/milestone-page'
import scadaPage from '@/components/scada-page'
import videoPage from '@/components/video-page'
export default {
  name: 'Home',
  components: {
    logoPage,
    milestonePage,
    scadaPage,
    videoPage
  },
  data () {
    return {
      isShowBg: false,
      PAGE: {
        LOGO: 1,
        MILESTONE: 2,
        SCADA: 3,
        VIDEO: 4
      },
      currentPage: null
    }
  },
  mounted () {
    this.currentPage = this.PAGE.LOGO
  },
  methods: {
    bgShowUp () {
      this.isShowBg = true
    },
    goTo (page) {
      console.log('go to page: ' + page)
      this.currentPage = page
    },
    showLastPage () {
      this.currentPage = this.PAGE.VIDEO
    }
  }
}
</script>

<style lang="scss">
.step { position: absolute; }

.home {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  background-image: radial-gradient(circle at 50% 37%, transparent, #ffffff 98%);

  &.fade-in {
    animation-name: showBackgroundGradient;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }
}

@keyframes showBackgroundGradient {
  0%   { background-color: #ffffff; }
  100% { background-color: rgba(0, 172, 235, 0.2);}
}

</style>
